export function createDomElement(
  type: 'link' | 'script',
  file: string,
  fn?: () => void,
): {
  add(target: HTMLElement | ParentNode | null): void;
} {
  const element = document.createElement(type) as any;

  if (type === 'link') {
    element.rel = 'stylesheet';
    element.href = file;
  }

  if (type === 'script') {
    element.src = file;
    element.type = 'module';
  }

  element.crossOrigin = '';
  element.onload = fn;
  return {
    add(target: HTMLElement | ParentNode | null) {
      target?.prepend(element);
    },
  };
}
